module.exports = {"TXTCLI_Show_Upcoming_Only":{"id":"TXTCLI_Show_Upcoming_Only","defaultMessage":"Mostrar Apenas Próximos"}}